'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDOMInterface;
/*  weak */
function createDOMInterface(renderer, node) {
  var isHydrating = false;

  var DOMInterface = {
    /**
     * updates DOM node styles performantly
     *
     * @param {Function} node - DOM node
     * @param {Object} change - object describing the changes
     * @param {Object} renderer - the renderer which triggered the change
     */
    updateNode: function updateNode() {
      var change = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // setting the hydration flag to prevent DOM updates will immediately
      // get unset as soon as the rehydration process is done
      if (change.type === 'hydrate') {
        isHydrating = !change.done;
      }

      // only update DOM if the renderer is not hydrating at the moment
      if (!isHydrating) {
        // only use insertRule in production as browser devtools might have
        // weird behavior if used together with insertRule at runtime
        if (change.type === 'rule' && !change.media && process.env.NODE_ENV === 'production') {
          var sheet = node.sheet;
          // directly append new rules before media rules
          sheet.insertRule(change.selector + '{' + change.css + '}', sheet.cssRules.length);
        } else {
          node.textContent = renderer.renderToString();
        }
      }
    }
  };

  return DOMInterface;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/DOMInterface.js
// module id = 402
// module chunks = 0